/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_Rule_One_SetInputs */

const en_us2_exercise_personal_info_rule_one_set = /** @type {(inputs: Exercise_Personal_Info_Rule_One_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One set at a time. The sets of a workout are not added up.`)
};

const pt_br2_exercise_personal_info_rule_one_set = /** @type {(inputs: Exercise_Personal_Info_Rule_One_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma série de cada vez. As séries do treino não se somam.`)
};

const es_419_exercise_personal_info_rule_one_set = /** @type {(inputs: Exercise_Personal_Info_Rule_One_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una serie a la vez. Las series de un entrenamiento no se suman.`)
};

const pt_pt2_exercise_personal_info_rule_one_set = /** @type {(inputs: Exercise_Personal_Info_Rule_One_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma série de cada vez. As séries do treino não se somam.`)
};

const fr_fr2_exercise_personal_info_rule_one_set = /** @type {(inputs: Exercise_Personal_Info_Rule_One_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une série à la fois. Les séries d'une séance ne s'additionnent pas.`)
};

const de_de2_exercise_personal_info_rule_one_set = /** @type {(inputs: Exercise_Personal_Info_Rule_One_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immer ein Satz. Die Sätze eines Trainings werden nicht addiert.`)
};

const it_it2_exercise_personal_info_rule_one_set = /** @type {(inputs: Exercise_Personal_Info_Rule_One_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una serie alla volta. Le serie di un allenamento non si sommano.`)
};

/**
* | output |
* | --- |
* | "One set at a time. The sets of a workout are not added up." |
*
* @param {Exercise_Personal_Info_Rule_One_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_rule_one_set = /** @type {((inputs?: Exercise_Personal_Info_Rule_One_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_Rule_One_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_rule_one_set(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_rule_one_set(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_rule_one_set(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_rule_one_set(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_rule_one_set(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_rule_one_set(inputs)
	return en_us2_exercise_personal_info_rule_one_set(inputs)
});
export { exercise_personal_info_rule_one_set as "exercise-personal.info_rule_one_set" }